import { Checkbox as AntCheckbox } from "antd";
import type { CheckboxProps as AntCheckboxProps } from "antd";

interface CustomCheckboxProps extends AntCheckboxProps {
  label?: string;
  error?: string;
  labelClassName?: string;
}

export function Checkbox({ label, error, labelClassName, ...props }: CustomCheckboxProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName || "text-gray-700"}`}>
          {label}
        </label>
      )}
      <AntCheckbox {...props}>{props.children}</AntCheckbox>
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
